import React, { useState } from 'react';
import './QuizAssessment.css';

function QuizAssessment() {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [isComplete, setIsComplete] = useState(false);

  const questions = [
    {
      id: 1,
      question: "How would you rate your overall mood today?",
      type: "scale",
      scale: { min: 1, max: 10, minLabel: "Very Low", maxLabel: "Very High" }
    },
    {
      id: 2,
      question: "How many hours did you sleep last night?",
      type: "number",
      placeholder: "Enter hours (e.g., 7.5)"
    },
    {
      id: 3,
      question: "How is your stress level today?",
      type: "scale",
      scale: { min: 1, max: 10, minLabel: "Not Stressed", maxLabel: "Very Stressed" }
    },
    {
      id: 4,
      question: "Did you experience any of these today?",
      type: "multiselect",
      options: ["Anxiety", "Irritability", "Difficulty concentrating", "Fatigue", "None of these"]
    },
    {
      id: 5,
      question: "How many meals did you have today?",
      type: "choice",
      options: ["0", "1", "2", "3", "4+"]
    },
    {
      id: 6,
      question: "Did you exercise or engage in physical activity today?",
      type: "choice",
      options: ["Yes, vigorous exercise", "Yes, light exercise", "No"]
    },
    {
      id: 7,
      question: "How would you rate your energy level?",
      type: "scale",
      scale: { min: 1, max: 10, minLabel: "Exhausted", maxLabel: "Energetic" }
    },
    {
      id: 8,
      question: "Any additional notes about your day?",
      type: "text",
      placeholder: "Optional: Share anything else relevant..."
    }
  ];

  const handleAnswer = (questionId, value) => {
    setAnswers({ ...answers, [questionId]: value });
  };

  const handleMultiSelect = (questionId, option) => {
    const current = answers[questionId] || [];
    const updated = current.includes(option)
      ? current.filter(item => item !== option)
      : [...current, option];
    setAnswers({ ...answers, [questionId]: updated });
  };

  const handleNext = () => {
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    }
  };

  const handlePrevious = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  const handleSubmit = () => {
    console.log('Quiz submitted:', answers);
    setIsComplete(true);
  };

  const progress = ((currentQuestion + 1) / questions.length) * 100;
  const currentQ = questions[currentQuestion];

  if (isComplete) {
    return (
      <div className="quiz-assessment">
        <div className="quiz-complete">
          <div className="complete-icon">✓</div>
          <h2>Assessment Complete!</h2>
          <p>Thank you for completing today's assessment.</p>
          <p className="complete-message">
            Your responses have been recorded and will help us better understand your patterns.
          </p>
          <button 
            className="quiz-btn primary"
            onClick={() => {
              setCurrentQuestion(0);
              setAnswers({});
              setIsComplete(false);
            }}
          >
            Take Another Assessment
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="quiz-assessment">
      <div className="quiz-header">
        <h2>Daily Assessment</h2>
        <p>Answer a few questions about your day</p>
      </div>

      {/* Progress Bar */}
      <div className="progress-container">
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${progress}%` }}></div>
        </div>
        <span className="progress-text">
          Question {currentQuestion + 1} of {questions.length}
        </span>
      </div>

      {/* Question Card */}
      <div className="question-card">
        <h3 className="question-text">{currentQ.question}</h3>

        <div className="answer-section">
          {currentQ.type === 'scale' && (
            <div className="scale-input">
              <input
                type="range"
                min={currentQ.scale.min}
                max={currentQ.scale.max}
                value={answers[currentQ.id] || 5}
                onChange={(e) => handleAnswer(currentQ.id, parseInt(e.target.value))}
                className="slider"
              />
              <div className="scale-labels">
                <span>{currentQ.scale.minLabel}</span>
                <span className="scale-value">{answers[currentQ.id] || 5}</span>
                <span>{currentQ.scale.maxLabel}</span>
              </div>
            </div>
          )}

          {currentQ.type === 'number' && (
            <input
              type="number"
              step="0.5"
              placeholder={currentQ.placeholder}
              value={answers[currentQ.id] || ''}
              onChange={(e) => handleAnswer(currentQ.id, e.target.value)}
              className="number-input"
            />
          )}

          {currentQ.type === 'choice' && (
            <div className="choice-options">
              {currentQ.options.map(option => (
                <button
                  key={option}
                  className={`choice-btn ${answers[currentQ.id] === option ? 'selected' : ''}`}
                  onClick={() => handleAnswer(currentQ.id, option)}
                >
                  {option}
                </button>
              ))}
            </div>
          )}

          {currentQ.type === 'multiselect' && (
            <div className="multiselect-options">
              {currentQ.options.map(option => (
                <button
                  key={option}
                  className={`multiselect-btn ${(answers[currentQ.id] || []).includes(option) ? 'selected' : ''}`}
                  onClick={() => handleMultiSelect(currentQ.id, option)}
                >
                  {option}
                </button>
              ))}
            </div>
          )}

          {currentQ.type === 'text' && (
            <textarea
              placeholder={currentQ.placeholder}
              value={answers[currentQ.id] || ''}
              onChange={(e) => handleAnswer(currentQ.id, e.target.value)}
              className="text-input"
              rows="4"
            />
          )}
        </div>
      </div>

      {/* Navigation */}
      <div className="quiz-navigation">
        <button
          className="quiz-btn secondary"
          onClick={handlePrevious}
          disabled={currentQuestion === 0}
        >
          Previous
        </button>

        {currentQuestion === questions.length - 1 ? (
          <button
            className="quiz-btn primary"
            onClick={handleSubmit}
          >
            Submit Assessment
          </button>
        ) : (
          <button
            className="quiz-btn primary"
            onClick={handleNext}
          >
            Next
          </button>
        )}
      </div>
    </div>
  );
}

export default QuizAssessment;

















